// extracted by mini-css-extract-plugin
module.exports = {"inline-spinner":"Loaders_inline-spinner__ZxjfZ","inline-spinner__ring":"Loaders_inline-spinner__ring__JKxKa"};